var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),_c('div',{staticClass:"line cross-line"}),_c('video-list-comp')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('span',[_vm._v("视频详情")]),_c('span',{staticClass:"choose-space"},[_vm._v("更换")])])
}]

export { render, staticRenderFns }